
            const data = {"name":"ic_arrow_down","data":{"width":"11","height":"12","viewBox":"0 0 11 12","data":"<path pid=\"0\" d=\"M10.167 6.77L5.583 11m0 0L1 6.77M5.583 11V1\" _stroke=\"#ED2F5D\" stroke-width=\"1.667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#ED2F5D"}],"stopColors":[]}}
        
                module.exports = data
                